/**
 * Tela de abertura estática do index.html (SPEC 10.4): pinta antes do JS e sai no mesmo quadro em
 * que a primeira tela da suíte pinta (login, lançador, área). Cada tela de topo chama
 * `useRemoveSplash(pronta)`.
 */
import { useLayoutEffect } from 'react';

export const SPLASH_ID = 'rota-splash';

export function hasSplash(): boolean {
  return typeof document !== 'undefined' && document.getElementById(SPLASH_ID) != null;
}

export function removeSplash(): void {
  if (typeof document !== 'undefined') document.getElementById(SPLASH_ID)?.remove();
}

export function useRemoveSplash(ready = true): void {
  useLayoutEffect(() => {
    if (ready) removeSplash();
  }, [ready]);
}
